import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { Card, CardContent, Typography } from '@material-ui/core';
import { DeliveryToolbar, DeliveryTable } from './components';
import { Snackbar, SuccessSnackbar, TableProgress } from '../../components';
import { remove as removeCart } from '../../actions/cart';
import { logout } from '../../actions/authentication';
import { search as apiSearch } from '../../api/delivery';
import history from '../../helpers/history';
import { MODE_LIST } from 'constants/delivery';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
}));

const DeliveryList = (props) => {
  const classes = useStyles();

  const [message, setMessage] = useState({ open: false, autoHideDuration: null, severity: "success", title: "", messages: [] });
  const [deliveries, setDeliveries] = useState([]);
  const [page, setPage] = useState(0);
  const [searching, setSearching] = useState(false);
  
  // Search
  const handleSearch = (year, month) => {
    setSearching(true);
    apiSearch(year, month).then(response => {
      if (response.status === 200 && response.data.status) {
        // Map offers
        setPage(0);
        setDeliveries(response.data.data);
      }
      else {
        onApiError(response);
      }
      setSearching(false);
    });
  }
  
  const onApiError = (response) => {
    if (response.status === 401) {
      props.logout();
    }
    else {
      setMessage({
        open: true,
        autoHideDuration: null,
        severity: "error",
        title: "Error",
        messages: ["Ha ocurrido un error. Por favor inténtelo de nuevo."] });
    }
  }

  const handleClose = () => {
    setMessage({ ...message, open: false });
  };

  const onViewDelivery = (id) => {
    history.push('/delivery/' + id);
  }

  return (
    <div className={classes.root}>
      <DeliveryToolbar mode={MODE_LIST} title={"Entregas"} onFiltersChange={(year, month) => handleSearch(year, month)} />
      <div className={classes.content}>
        {searching ? <TableProgress /> :
          deliveries.length === 0 ?
          <Card>
            <CardContent>
              <Typography align="center">
                {"No se han encontrado resultados para su búsqueda."}
                </Typography>
              </CardContent>
          </Card>
        : 
        <DeliveryTable
          deliveries={deliveries}
          page={page}
          setPage={(page) => setPage(page)}
          onViewDelivery={(id) => onViewDelivery(id)}
        />}
      </div>
      <Snackbar
          open={message.open}
          autoHideDuration={message.autoHideDuration}
          severity={message.severity}
          title={message.title}
          messages={message.messages}
          handleClose={() => handleClose()}
        />
        <SuccessSnackbar />
    </div>
  );
};

const mapStateToProps = state => ({
  cart: state.cart
});

const mapDispatchToProps = dispatch => {
  return {
    logout: () => {
      dispatch(removeCart());
      dispatch(logout());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryList);